/* Night Markets · landing Asiamarché
   Barre des stands, apparitions, panneau recette, ajout au panier AJAX, jauge, compte à rebours. */
(function () {
  'use strict';

  var root = document.querySelector('[data-nm-root]');
  if (!root) return;
  root.classList.add('nm-js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ds = root.dataset;
  var themeSections = (ds.themeSections || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  var sectionIds = ['nm-jauge'].concat(themeSections).join(',');
  var routes = {
    cart: ds.cartUrl || '/cart',
    add: ds.cartAddUrl || '/cart/add',
    change: ds.cartChangeUrl || '/cart/change'
  };

  /* ---------- Apparitions au défilement ---------- */
  var revealEls = root.querySelectorAll('.nm-reveal, .nm-dish');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          revealObs.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { revealObs.observe(el); });
  }

  /* ---------- Barre des stands calée sous l'en-tête collant du thème ---------- */
  function syncNavTop() {
    if (parseInt(ds.navOffset || '0', 10) > 0) return;
    var header = document.querySelector('.section-header, #shopify-section-header');
    var h = 0;
    if (header) {
      var pos = window.getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') h = Math.round(header.getBoundingClientRect().height);
    }
    root.style.setProperty('--nm-nav-top', h + 'px');
  }
  syncNavTop();
  window.addEventListener('resize', syncNavTop);
  window.addEventListener('load', syncNavTop);

  /* ---------- Barre des stands ---------- */
  var pillsBox = root.querySelector('[data-nm-pills]');
  var pills = root.querySelectorAll('[data-nm-pill]');
  function setActive(id) {
    pills.forEach(function (p) {
      var on = p.getAttribute('data-nm-pill') === id;
      p.classList.toggle('is-active', on);
      if (on) {
        p.setAttribute('aria-current', 'true');
        if (pillsBox) {
          var left = p.offsetLeft - (pillsBox.clientWidth - p.clientWidth) / 2;
          pillsBox.scrollTo({ left: Math.max(0, left), behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      } else {
        p.removeAttribute('aria-current');
      }
    });
  }
  if (pills.length && 'IntersectionObserver' in window) {
    var navObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) setActive(e.target.id); });
    }, { rootMargin: '-35% 0px -60% 0px' });
    root.querySelectorAll('[data-nm-section]').forEach(function (s) { navObs.observe(s); });
  }

  /* ---------- Panneau recette ---------- */
  root.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-nm-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-nm-open'));
      if (dlg && typeof dlg.showModal === 'function') {
        dlg.showModal();
        document.documentElement.classList.add('nm-lock');
      }
      return;
    }
    if (e.target.closest('[data-nm-close]')) {
      var d = e.target.closest('dialog');
      if (d) d.close();
    }
  });
  root.querySelectorAll('dialog.nm-sheet').forEach(function (dlg) {
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('nm-lock'); });
  });

  /* ---------- Compte à rebours ---------- */
  var countdown = root.querySelector('[data-nm-countdown]');
  var debut = Date.parse(ds.debut);
  var fin = Date.parse(ds.fin);
  var seuilH = parseInt(ds.countdownHeures || '0', 10);
  function duree(ms) {
    var m = Math.floor(ms / 60000);
    var j = Math.floor(m / 1440);
    var h = Math.floor((m % 1440) / 60);
    var min = m % 60;
    return (j ? j + ' j ' : '') + (j || h ? h + ' h ' : '') + min + ' min';
  }
  function tick() {
    if (!countdown || isNaN(fin)) return;
    var now = Date.now();
    var reste = fin - now;
    var visible = seuilH > 0 && now >= (isNaN(debut) ? 0 : debut) && reste > 0 && reste <= seuilH * 3600000;
    countdown.hidden = !visible;
    if (visible) countdown.textContent = 'Fin dans ' + duree(reste);
  }
  tick();
  setInterval(tick, 30000);

  /* ---------- Panier ---------- */
  var lines = {}; // variantId -> { key, qty }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function readCart(cart) {
    lines = {};
    (cart.items || []).forEach(function (it) {
      var id = String(it.variant_id);
      if (!lines[id]) lines[id] = { key: it.key, qty: it.quantity };
    });
    root.querySelectorAll('[data-nm-card]').forEach(paintCard);
    updateCount(cart.item_count);
  }

  function paintCard(card) {
    var line = lines[card.getAttribute('data-variant-id')];
    var q = line ? line.qty : 0;
    var form = card.querySelector('[data-nm-add]');
    var qty = card.querySelector('[data-nm-qty]');
    if (!form || !qty) return;
    form.hidden = q > 0;
    qty.hidden = q === 0;
    qty.querySelector('[data-nm-count]').textContent = q;
  }

  function updateCount(n) {
    if (!ds.compteur) return;
    try {
      document.querySelectorAll(ds.compteur).forEach(function (el) { el.textContent = n; });
    } catch (err) { /* sélecteur invalide */ }
  }

  function refreshCart() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(readCart);
  }

  function replaceThemeSections(sections) {
    if (!sections) return;
    themeSections.forEach(function (id) {
      var html = sections[id];
      var target = document.getElementById('shopify-section-' + id);
      if (!html || !target) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + id) || doc.body;
      target.innerHTML = fresh.innerHTML;
    });
  }

  function notifyTheme(cart) {
    /* Thème Canopy : rafraîchit le tiroir panier et le compteur de l'en-tête */
    if (window.theme && typeof window.theme.updateCartSummaries === 'function') {
      try { window.theme.updateCartSummaries(ds.ouvrirTiroir === 'true'); } catch (err) { /* thème indisponible */ }
    }
    ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart || null, source: 'night-markets' } }));
    });
  }

  /* ---------- Toast avec la jauge ---------- */
  var toast = root.querySelector('[data-nm-toast]');
  var toastTitre = root.querySelector('[data-nm-toast-titre]');
  var toastCorps = root.querySelector('[data-nm-toast-corps]');
  var toastTimer;
  function showToast(titre, jaugeHtml, erreur) {
    if (!toast) return;
    toastTitre.textContent = titre;
    toastTitre.classList.toggle('is-erreur', !!erreur);
    toastCorps.innerHTML = '';
    if (jaugeHtml) {
      var doc = new DOMParser().parseFromString(jaugeHtml, 'text/html');
      var jauge = doc.querySelector('[data-nm-jauge]');
      var style = doc.querySelector('style');
      if (style) toastCorps.appendChild(style);
      if (jauge) toastCorps.appendChild(jauge);
    }
    toast.hidden = false;
    var inner = toast.firstElementChild;
    inner.style.animation = 'none';
    void inner.offsetWidth;
    inner.style.animation = '';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, erreur ? 6000 : 5000);
  }
  if (toast) {
    toast.addEventListener('mouseenter', function () { clearTimeout(toastTimer); });
    toast.addEventListener('mouseleave', function () { toastTimer = setTimeout(function () { toast.hidden = true; }, 2500); });
  }

  function afterChange(sections, titre) {
    replaceThemeSections(sections);
    showToast(titre, sections && sections['nm-jauge']);
  }

  function busy(el, on) {
    if (!el) return;
    if (on) el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy');
  }

  /* Ajouter */
  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-nm-add]');
    if (!form) return;
    e.preventDefault();
    var card = form.closest('[data-nm-card]');
    var btn = form.querySelector('button');
    if (btn.getAttribute('aria-busy') === 'true') return;
    busy(btn, true);
    postJSON(routes.add + '.js', {
      items: [{ id: Number(card.getAttribute('data-variant-id')), quantity: 1 }],
      sections: sectionIds,
      sections_url: window.location.pathname
    })
      .then(function (data) {
        afterChange(data.sections, 'Ajouté au panier');
        return refreshCart().then(function () {
          var plus = card.querySelector('[data-nm-inc]');
          if (plus) plus.focus();
          notifyTheme();
        });
      })
      .catch(function (err) {
        showToast((err && (err.description || err.message)) || "L'ajout au panier n'a pas fonctionné. Réessayez.", null, true);
      })
      .then(function () { busy(btn, false); });
  });

  /* Plus / moins */
  root.addEventListener('click', function (e) {
    var inc = e.target.closest('[data-nm-inc]');
    var dec = e.target.closest('[data-nm-dec]');
    if (!inc && !dec) return;
    var card = e.target.closest('[data-nm-card]');
    var box = card.querySelector('[data-nm-qty]');
    if (box.getAttribute('aria-busy') === 'true') return;
    var line = lines[card.getAttribute('data-variant-id')];
    if (!line) return;
    var next = Math.max(0, line.qty + (inc ? 1 : -1));
    busy(box, true);
    postJSON(routes.change + '.js', {
      id: line.key,
      quantity: next,
      sections: sectionIds,
      sections_url: window.location.pathname
    })
      .then(function (cart) {
        readCart(cart);
        afterChange(cart.sections, next === 0 ? 'Retiré du panier' : 'Panier mis à jour');
        if (next === 0) {
          var add = card.querySelector('[data-nm-add] button');
          if (add) add.focus();
        }
        notifyTheme(cart);
      })
      .catch(function (err) {
        showToast((err && (err.description || err.message)) || "La mise à jour du panier n'a pas fonctionné. Réessayez.", null, true);
      })
      .then(function () { busy(box, false); });
  });

  /* Cartes produit du thème : si le thème ne gère pas l'ajout en AJAX sur cette page,
     on l'assure ici (écoute posée sur window, donc après les gestionnaires du thème). */
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || e.defaultPrevented || !root.contains(form) || !form.closest('.product-block')) return;
    var fd = new FormData(form);
    var id = fd.get('id');
    if (!id) return;
    e.preventDefault();
    var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
    postJSON(routes.add + '.js', {
      items: [{ id: Number(id), quantity: qty }],
      sections: sectionIds,
      sections_url: window.location.pathname
    })
      .then(function (data) {
        afterChange(data.sections, 'Ajouté au panier');
        notifyTheme();
      })
      .catch(function (err) {
        showToast((err && (err.description || err.message)) || "L'ajout au panier n'a pas fonctionné. Réessayez.", null, true);
      });
  });

  /* Aperçu de la jauge avant le lancement : ?nm_preview=1 (désactiver avec ?nm_preview=0) */
  var nmPreview = new URLSearchParams(window.location.search).get('nm_preview');
  if (nmPreview === '1' || nmPreview === '0') {
    postJSON(routes.cart.replace(/\/$/, '') + '/update.js', { attributes: { _nm_preview: nmPreview === '1' ? '1' : '' } }).catch(function () {});
  }

  if (toast) {
    toast.addEventListener('click', function (e) {
      if (!e.target.closest('a')) toast.hidden = true;
    });
  }

  /* État initial : cartes déjà au panier */
  refreshCart().catch(function () {});

  /* Panier modifié ailleurs (tiroir du thème, autre onglet) */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refreshCart().catch(function () {});
  });
})();